/**
 * XtsPointCloudCurve3 — Three.js Curve3 wrapper around the Free-path sample.
 *
 * The off-by-one clamp at s == ModuleLength is handled in
 * pathMath.sampleModulePath.
 */

import { Curve, Vector3 } from 'three';
import type { ModuleCatalogEntry } from './ModuleCatalog.js';
import { sampleModulePath } from './pathMath.js';

export class XtsPointCloudCurve3 extends Curve<Vector3> {
  public readonly module: ModuleCatalogEntry;

  constructor(module: ModuleCatalogEntry) {
    super();
    if (module.pathType !== 'Free') {
      throw new Error(
        `XtsPointCloudCurve3 requires pathType='Free', got "${module.pathType}"`,
      );
    }
    this.module = module;
  }

  override getPoint(t: number, optionalTarget = new Vector3()): Vector3 {
    const s = t * this.module.moduleLengthMm;
    const sample = sampleModulePath(this.module, s);
    return optionalTarget.set(
      sample.positionMm[0],
      sample.positionMm[1],
      sample.positionMm[2],
    );
  }

  override getTangent(t: number, optionalTarget = new Vector3()): Vector3 {
    const s = t * this.module.moduleLengthMm;
    const sample = sampleModulePath(this.module, s);
    return optionalTarget
      .set(sample.tangent[0], sample.tangent[1], sample.tangent[2])
      .normalize();
  }

  override getLength(): number {
    return this.module.moduleLengthMm;
  }
}
